import React from 'react';

function ProductForm({ formData, handleChange, handleSubmit, categories, titresOptions }) {
  return (
    <form onSubmit={handleSubmit} encType="multipart/form-data" className="product-form">

      <select name="categorie_id" value={formData.categorie_id} onChange={handleChange} required>
        <option value="">-- Choisir une catégorie --</option>
        {categories.map((cat) => (
          <option key={cat.id} value={cat.id}>{cat.categorie}</option>
        ))}
      </select>

      <select name="titre_id" value={formData.titre_id} onChange={handleChange} required>
        <option value="">-- Choisir un titre --</option>
        {titresOptions.map((titre) => (
          <option key={titre.id} value={titre.id}>{titre.title}</option>
        ))}
      </select>

      <input
        name="description"
        placeholder="Description courte"
        value={formData.description}
        onChange={handleChange}
        required
      />

      <textarea
        name="description_detaillee"
        placeholder="Description détaillée"
        value={formData.description_detaillee}
        onChange={handleChange}
      />

      <input
        name="price"
        type="number"
        placeholder="Prix (Ar)"
        value={formData.price}
        onChange={handleChange}
        required
      />

      <input
        name="stock"
        type="number"
        placeholder="Stock disponible"
        value={formData.stock}
        onChange={handleChange}
        required
      />

      <input
        name="lieu"
        placeholder="Lieu de production"
        value={formData.lieu}
        onChange={handleChange}
      />

      <input
        name="unite"
        placeholder="Unité (kg, litre...)"
        value={formData.unite}
        onChange={handleChange}
      />

      <input
        name="quantite_min"
        type="number"
        placeholder="Quantité minimale"
        value={formData.quantite_min}
        onChange={handleChange}
      />
      <button type="submit">✅ Enregistrer</button>
    </form>
  );
}

export default ProductForm;
